import { ASK_QUESTION_KEY } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { RovoLabsConfirmedTools } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

import type { DisambiguationAttributes } from './get-confluence-result-acceptance-attributes-for-ask-question';
import { isConfluenceCreatableAction, isConfluenceUpdatableAction } from './index';

type DisambiguationAttributesForConfirmedMessageParams = {
	actions: MessageAction[] | undefined;
	confirmedTools: RovoLabsConfirmedTools;
};

const wasAskQuestionConfirmed = (confirmedTools: RovoLabsConfirmedTools): boolean =>
	confirmedTools.tools.some(
		(tool) => tool.key === ASK_QUESTION_KEY && tool.resolution?.type !== 'cancelled',
	);

export function getDisambiguationAttributesForConfirmedMessage({
	actions,
	confirmedTools,
}: DisambiguationAttributesForConfirmedMessageParams): Partial<DisambiguationAttributes> {
	if (!wasAskQuestionConfirmed(confirmedTools)) {
		return {};
	}

	return {
		disambiguationUsedOnCreation: (actions ?? []).some((action) =>
			isConfluenceCreatableAction({ key: action.key }),
		),
		disambiguationUsedOnEdit: (actions ?? []).some((action) =>
			isConfluenceUpdatableAction({ key: action.key }),
		),
	};
}
